import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY } from '@/swagger/constants/credits-keys';
import {
  API_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY,
  KEY_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY,
} from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY } from '../mocks';

type RequestPostEmployerCreditsSummaryByCategory = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY
>['request']['body'];

type ResponsePostEmployerCreditsSummaryByCategory = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY
>['response']['body'];

export type CallParamsPostEmployerCreditsSummaryByCategory = Omit<
  RequestPostEmployerCreditsSummaryByCategory,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployerCreditsSummaryByCategory =
  ResponsePostEmployerCreditsSummaryByCategory;

type CallErrorPostEmployerCreditsSummaryByCategory = {
  message: string;
  code: number;
};

type CallSelectorsPostEmployerCreditsSummaryByCategory = unknown;

export const postEmployerCreditsSummaryByCategoryCall = createGeneralCall<
  CallParamsPostEmployerCreditsSummaryByCategory,
  CallResponsePostEmployerCreditsSummaryByCategory,
  CallErrorPostEmployerCreditsSummaryByCategory,
  CallSelectorsPostEmployerCreditsSummaryByCategory
>({
  id: KEY_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED()
    ? MOCK_RESPONSE_POST_EMPLOYER_CREDITS_SUMMARY_BY_CATEGORY
    : undefined,
});
